import React, { useState } from 'react';
import styled from 'styled-components';
import { WindowDropDowns } from 'components';
import dropDownData from './dropDownData';
import windows from 'assets/windowsIcons/windows.png';
import folder from 'assets/windowsIcons/318(16x16).png';
import pullup from 'assets/windowsIcons/pullup.png';
import dropdown from 'assets/windowsIcons/dropdown.png';
import go from 'assets/windowsIcons/290.png';
import documents from 'assets/windowsIcons/308(32x32).png';

const files = [
  {
    id: 1,
    name: 'final_roadmap_FINAL_v3_USE_THIS_ONE.pptx',
    icon: '📊',
    size: '4.2 MB',
    modified: '2/14/2025',
    content: `PRODUCT ROADMAP Q1-Q4 2025
"This time it's real"

Q1: Foundation
- "Align stakeholders" (translation: survive 14 meetings)
- Define MVP (then redefine it twice)
- Set KPIs nobody will track after month 1

Q2: Build
- Actually build stuff
- Realize Q1 assumptions were wrong
- Pivot. Reframe pivot as "strategic evolution"

Q3: Launch
- Launch soft (translation: show 3 customers)
- Collect "learnings"
- Update slide 7 of this deck

Q4: Scale
- "We'll figure this out in Q4"
- (Narrator: They did not figure it out in Q4.)

APPROVED BY: Mahip
APPROVED BY (revised): Still Mahip
APPROVED BY (final, for real this time): Mahip`,
  },
  {
    id: 2,
    name: 'stakeholder_alignment_HELP_ME.docx',
    icon: '📝',
    size: '892 KB',
    modified: '3/1/2025',
    content: `STAKEHOLDER ALIGNMENT TRACKER
"Because someone has to"

STAKEHOLDERS:
1. The CEO — wants "AI everywhere, yesterday"
   Status: Aligned (he doesn't know what RAG is and I'm keeping it that way)

2. Engineering — wants clear requirements
   Status: Negotiating (they want wireframes, I give them vibes)

3. Legal — "have you considered the risks?"
   Status: Avoided (they're still reviewing my email from November)

4. Finance — "what's the ROI?"
   Status: Pending (I said "efficiency gains" 14 times. They nodded.)

5. The User — our actual customer
   Status: Not yet consulted
   (see action item #1: "schedule user interviews")
   (action item #1 has been on this doc since March)

ACTION ITEMS:
□ Schedule user interviews (moved from last quarter)
□ Get Legal to reply
□ Explain to CEO what "training data" means without alarming him
□ Find out what Finance actually does`,
  },
  {
    id: 3,
    name: 'meeting_notes_couldve_been_an_email.txt',
    icon: '📄',
    size: '12 KB',
    modified: '3/10/2025',
    content: `MEETING: AI Strategy Sync — Weekly Recurring (kill me)
DATE: Every. Single. Monday. 9am.
ATTENDEES: 11 people (7 optional, 4 mandatory, 0 prepared)

AGENDA (sent at 8:57am):
1. Status updates
2. Blockers
3. AOB

WHAT ACTUALLY HAPPENED:
9:00 — "Can everyone hear me?" (4 minutes)
9:04 — Dave shares wrong screen (2 minutes)
9:06 — Status updates begin
9:06 — Status update derails into tangent about a system nobody uses
9:24 — Circled back to agenda item 1
9:31 — "We're running low on time, let's take this offline"
9:32 — Meeting ends
9:33 — Mahip writes this

DECISIONS MADE: 0
ACTION ITEMS: 3 (none assigned)
NET VALUE CREATED: debatable

COULD THIS HAVE BEEN AN EMAIL?
Yes. It could have been a Slack message.
It could have been nothing.`,
  },
  {
    id: 4,
    name: 'prompts_that_actually_work_DO_NOT_DELETE.txt',
    icon: '🤖',
    size: '38 KB',
    modified: '3/15/2025',
    content: `# MAHIP'S PROMPT LIBRARY
# Compiled over 2 years of trial, error, and mild despair
# DO NOT DELETE (yes I'm talking to you, Past Me)

## GENERAL PURPOSE
"You are an expert [role]. Think step by step. Be concise but thorough.
Do not make things up. If you don't know, say so."
→ Works 80% of the time, 100% of the time.

## FOR SUMMARIZATION
"Summarize the following in 3 bullet points for a non-technical executive
who is smart but has 0 context and 4 minutes."
→ Gold. Pure gold.

## FOR HALLUCINATION REDUCTION
"Before answering, state what you know for certain vs. what you're inferring.
If you're unsure, say UNCERTAIN: before that sentence."
→ Doesn't stop it. But at least you know.

## FOR CODE REVIEW
"Review this code. List: bugs, security issues, performance concerns, and
anything that will make a senior engineer raise an eyebrow."
→ The eyebrow thing helps. No idea why.

## THE MAGIC PROMPT (use sparingly)
"Pretend you're the world's most pragmatic product manager who has seen
every enterprise AI project fail and knows exactly why. Review my plan."
→ Brutal. Effective. Slightly depressing.

## PROMPTS THAT DO NOT WORK
"Be creative" → too vague
"Think outside the box" → what box? which box?
"Just do your best" → it always does. that's the problem.`,
  },
  {
    id: 5,
    name: 'ai_hype_vs_reality_tracker.xlsx',
    icon: '📈',
    size: '2.1 MB',
    modified: '2/28/2025',
    content: `AI HYPE VS REALITY TRACKER 2024-2025

THING         | CLAIMED           | REALITY
--------------+-------------------+--------------------------
AGI           | "6 months away"   | Has been 6 months away
              |                   | since 2019
--------------+-------------------+--------------------------
LLMs          | "Will replace     | Replaced "junior dev
              | developers"       | who googled things"
--------------+-------------------+--------------------------
RAG           | "Solves           | Solves hallucination if
              | hallucination"    | you set it up right,
              |                   | which takes 3 sprints
--------------+-------------------+--------------------------
Agents        | "Autonomous!"     | Autonomous-ish. Mostly
              |                   | needs babysitting
--------------+-------------------+--------------------------
Prompt Eng.   | "Not a real job"  | Is now a real job
--------------+-------------------+--------------------------
Enterprise AI | "Quick win"       | 6-month procurement
              |                   | process + legal review
--------------+-------------------+--------------------------
"AI-powered"  | Transformative    | Often a regex with
              |                   | a chatbot on top

STATUS: Still updating. Will never be done.`,
  },
  {
    id: 6,
    name: 'burndown_chart_lol.png',
    icon: '📉',
    size: '156 KB',
    modified: '3/5/2025',
    content: `[IMAGE FILE: burndown_chart_lol.png]

What this chart shows:
↘ Sprint 1: things going great
↘ Sprint 2: slight slope downward
→ Sprint 3: suspiciously flat line (scope was "clarified")
↗ Sprint 4: somehow more work than we started with
↘↗ Sprint 5-8: the "we'll catch up next sprint" era
→→→ Sprint 9: line goes horizontal. We have accepted our fate.

The PM's note (added in MS Paint):
"This is fine 🔥"

Presented to leadership as:
"We're taking a measured approach to delivery velocity."

They nodded.`,
  },
  {
    id: 7,
    name: 'my_actual_priorities.txt',
    icon: '🔒',
    size: '4 KB',
    modified: '1/1/2025',
    content: `MY ACTUAL PRIORITIES (not for sharing)
=======================================

1. Ship things that matter to real users
   (radical, I know)

2. Say no to bad ideas (even my own)

3. Never lose sight of why we're building this

4. Make the team's life better, not harder

5. Learn something new every week

6. Document things properly
   (I wrote this at midnight. Still counts.)

7. Eat lunch.
   (seriously. calendar block it.)

8. Remember: perfect is the enemy of shipped

9. Be the kind of PM engineers actually want to work with

10. Have fun. Life's too short for joyless sprints.

---
Written: 1 Jan 2025, 12:04am
Still valid: yes
Still following: trying`,
  },
];

function MyDocuments({ onClose }) {
  const [selectedFile, setSelectedFile] = useState(null);
  const [openFile, setOpenFile] = useState(null);

  function onClickOptionItem(item) {
    if (item === 'Close') onClose();
  }

  function onDoubleClickFile(file) {
    setOpenFile(file);
  }

  return (
    <Div>
      <section className="com__toolbar">
        <div className="com__options">
          <WindowDropDowns items={dropDownData} onClickItem={onClickOptionItem} />
        </div>
        <img className="com__windows-logo" src={windows} alt="windows" />
      </section>
      <section className="com__address_bar">
        <div className="com__address_bar__title">Address</div>
        <div className="com__address_bar__content">
          <img src={folder} alt="" className="com__address_bar__content__img" />
          <div className="com__address_bar__content__text">C:\Documents and Settings\Mahip\My Documents</div>
          <img src={dropdown} alt="" className="com__address_bar__content__img" />
        </div>
        <div className="com__address_bar__go">
          <img className="com__address_bar__go__img" src={go} alt="go" />
          <span className="com__address_bar__go__text">Go</span>
        </div>
      </section>
      <div className="com__content">
        <div className="com__left-panel">
          <div className="panel-card">
            <div className="panel-card-header">
              <span>File and Folder Tasks</span>
              <img src={pullup} alt="" style={{width:16,height:16}} />
            </div>
            <div className="panel-card-body">
              <div className="panel-link">📁 Make a new folder</div>
              <div className="panel-link">🌐 Publish to Web</div>
              <div className="panel-link">📧 Share this folder</div>
            </div>
          </div>
          <div className="panel-card" style={{marginTop:8}}>
            <div className="panel-card-header">
              <span>Details</span>
              <img src={pullup} alt="" style={{width:16,height:16}} />
            </div>
            <div className="panel-card-body">
              {selectedFile ? (
                <>
                  <div style={{fontWeight:'bold', marginBottom:4}}>{selectedFile.name}</div>
                  <div>Size: {selectedFile.size}</div>
                  <div>Modified: {selectedFile.modified}</div>
                </>
              ) : (
                <div style={{color:'#666', fontSize:10}}>
                  <img src={documents} alt="" style={{width:32,height:32,display:'block',margin:'0 auto 4px'}} />
                  My Documents<br/>
                  {files.length} objects
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="com__file-list">
          {files.map(file => (
            <div
              key={file.id}
              className={`file-item${selectedFile && selectedFile.id === file.id ? ' selected' : ''}`}
              onClick={() => setSelectedFile(file)}
              onDoubleClick={() => onDoubleClickFile(file)}
            >
              <span className="file-icon">{file.icon}</span>
              <span className="file-name">{file.name}</span>
            </div>
          ))}
        </div>
      </div>
      {openFile && (
        <div className="file-viewer-overlay" onClick={() => setOpenFile(null)}>
          <div className="file-viewer" onClick={e => e.stopPropagation()}>
            <div className="file-viewer-header">
              <span>{openFile.icon} {openFile.name}</span>
              <button onClick={() => setOpenFile(null)}>✕</button>
            </div>
            <pre className="file-viewer-content">{openFile.content}</pre>
          </div>
        </div>
      )}
      <div className="com__statusbar">
        {selectedFile ? `1 object(s) selected — ${selectedFile.size}` : `${files.length} object(s)`}
      </div>
    </Div>
  );
}

const Div = styled.div`
  height: 100%;
  width: 100%;
  position: absolute;
  display: flex;
  overflow: hidden;
  flex-direction: column;
  background: linear-gradient(to right, #edede5 0%, #ede8cd 100%);
  font-size: 11px;

  .com__toolbar {
    position: relative;
    display: flex;
    align-items: center;
    height: 24px;
    border-bottom: 1px solid rgba(255,255,255,0.7);
    flex-shrink: 0;
  }
  .com__options {
    height: 23px;
    border-bottom: 1px solid rgba(0,0,0,0.1);
    border-right: 1px solid rgba(0,0,0,0.1);
    padding: 1px 0 1px 2px;
    flex: 1;
  }
  .com__windows-logo {
    height: 100%;
    border-left: 1px solid white;
    border-bottom: 1px solid rgba(0,0,0,0.1);
  }
  .com__address_bar {
    flex-shrink: 0;
    border-top: 1px solid rgba(255,255,255,0.7);
    height: 20px;
    font-size: 11px;
    display: flex;
    align-items: center;
    padding: 0 2px;
    box-shadow: inset 0 -2px 3px -1px #b0b0b0;
  }
  .com__address_bar__title { color: rgba(0,0,0,0.5); padding: 5px; }
  .com__address_bar__content {
    border: rgba(122,122,255,0.6) 1px solid;
    height: 100%;
    display: flex;
    flex: 1;
    align-items: center;
    background-color: white;
    position: relative;
    &__img { width: 14px; height: 14px; }
    &__img:last-child { width: 15px; height: 15px; right: 1px; position: absolute; }
    &__text { white-space: nowrap; position: absolute; left: 16px; right: 17px; overflow: hidden; }
  }
  .com__address_bar__go {
    display: flex;
    align-items: center;
    padding: 0 18px 0 5px;
    height: 100%;
    position: relative;
    &__img { height: 95%; border: 1px solid rgba(255,255,255,0.2); margin-right: 3px; }
  }
  .com__content {
    flex: 1;
    display: flex;
    overflow: hidden;
    border: 1px solid rgba(0,0,0,0.4);
    border-top-width: 0;
    background: #f1f1f1;
  }
  .com__left-panel {
    width: 160px;
    min-width: 160px;
    background: linear-gradient(to bottom, #c5d7ff 0%, #b8cbff 100%);
    border-right: 1px solid #8cacff;
    padding: 8px;
    overflow-y: auto;
  }
  .panel-card {
    border: 1px solid #7aa2e3;
    background: white;
    overflow: hidden;
  }
  .panel-card-header {
    background: linear-gradient(to right, #dce8ff, #aac4ff);
    padding: 3px 6px;
    font-weight: bold;
    font-size: 10px;
    color: #0c327d;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .panel-card-body { padding: 6px; font-size: 10px; color: #333; }
  .panel-link {
    color: #0c327d;
    margin: 3px 0;
    cursor: pointer;
    &:hover { color: #2b72ff; text-decoration: underline; }
  }
  .com__file-list {
    flex: 1;
    overflow-y: auto;
    background: white;
    padding: 4px;
    display: flex;
    flex-direction: column;
    gap: 2px;
  }
  .file-item {
    display: flex;
    align-items: center;
    padding: 3px 6px;
    cursor: default;
    border: 1px solid transparent;
    user-select: none;
    &:hover { background: #e8f0ff; border-color: #aac4ff; }
    &.selected { background: #3169c4; color: white; border-color: #1a4a9f; }
    &.selected .file-name { color: white; }
  }
  .file-icon { font-size: 16px; margin-right: 6px; flex-shrink: 0; }
  .file-name { font-size: 11px; color: #000; word-break: break-all; }
  .com__statusbar {
    height: 18px;
    background: #ece9d8;
    border-top: 1px solid rgba(0,0,0,0.2);
    display: flex;
    align-items: center;
    padding: 0 6px;
    font-size: 10px;
    color: #333;
    flex-shrink: 0;
  }
  .file-viewer-overlay {
    position: absolute;
    top: 0; left: 0; right: 0; bottom: 0;
    background: rgba(0,0,0,0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 100;
  }
  .file-viewer {
    background: white;
    border: 2px solid #0831d9;
    width: 85%;
    max-height: 80%;
    display: flex;
    flex-direction: column;
    box-shadow: 4px 4px 12px rgba(0,0,0,0.5);
  }
  .file-viewer-header {
    background: linear-gradient(to bottom, #0058ee, #0040ab);
    color: white;
    padding: 4px 8px;
    font-weight: bold;
    font-size: 11px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-shrink: 0;
    button {
      background: none;
      border: none;
      color: white;
      cursor: pointer;
      font-size: 12px;
      font-weight: bold;
      &:hover { opacity: 0.8; }
    }
  }
  .file-viewer-content {
    flex: 1;
    overflow: auto;
    padding: 12px;
    font-family: 'Lucida Console', monospace;
    font-size: 11px;
    line-height: 1.5;
    color: #222;
    white-space: pre-wrap;
    margin: 0;
  }
`;

export default MyDocuments;
